exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirmation-modal div {\n  text-align: center;\n}\n.confirmation-modal div.modal-header {\n  padding-top: 40px;\n  border-bottom: none;\n}\n.confirmation-modal div.modal-header div.modal-title {\n  font-size: 30px;\n  padding-top: 10px;\n  font-weight: 900;\n}\n.confirmation-modal div.modal-body {\n  font-size: 16px;\n}\n.confirmation-modal div.modal-footer {\n  border-top: none;\n  padding-bottom: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/a2i/styles/ConfirmationModal.styl
// module id = 927
// module chunks = 0 1